<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from 'axios';

import {
  required,
  //email,
  minLength,
  //sameAs,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "Brand",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      title: "Brand registration",
      items: [
        {
          text: "Equipment",
          href: "/"
        },
        {
          text: "Brands",
          href: "/equipment/brands"
        },
        {
          text: "Brand",
          active: true
        }
      ],
      form: {
        id_categories:  [],
        nm_brand:   "",
      },
      submitted:    false,
      isLoading:    false,
      user:         {},
      categories:   [],
      brands:       [],
    };
  },
  validations: {
    form: {
      id_categories: {required},
      nm_brand: {required, minLength: minLength(2), maxLength: maxLength(50)},
    }
  },
  watch:{},
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    this.getCategories();
    if( this.$route.params.id ){
      this.getBrandByID( this.$route.params.id );
    }
  },
  methods: {

    getCategories(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/categories.php',
        {
          params: {
            request: 'getCategoriesForMultipleSelect',
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.categories  = response.data;
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getBrandByID(idBrand){
      let app = this;

      Swal.fire({
        title: "Loading brand data.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });


      axios
      .get(
        window.serverPath+'dist/mvw/controllers/brands.php',
        {
          params: {
            request: 'getBrandByID',
            id: idBrand
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.form.id_brand           = response.data.id_brand;
            app.form.nm_brand           = response.data.nm_brand;

            var auxCats = [];
            for (var i=0; i<response.data.id_categories.length; i++) {
              auxCats.push( Number(response.data.id_categories[i]) );
            }
            response.data.id_categories = auxCats;

            app.form.id_categories      = response.data.id_categories;
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          app.$swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },


    // eslint-disable-next-line no-unused-vars
    saveBrand(e) {
      let app = this;
      let successMessage = "";

      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_brand  = this.$route.params.id;
        }

        Swal.fire({
          title: "Saving brand.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/brands.php', {
          request: 'saveBrand',
          data: this.form, 
        })
        .then(function (response) {
          let action = "";

          if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
          if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
          if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }
          
          if( response.data === "OK" ){
            action = "saved";
          }
          if( response.data === "UPDATED" ){
            action = "updated";
          }

          Swal.fire("Good job!", "The brand is correct "+action+"!", "success");
          app.$router.push({ name: 'brands' });



          if(response.data){
            Swal.fire(
              'Congrats!!!','<p><b>'+successMessage+'</b></p>',
              'success',
            ).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                app.$router.push({ name: 'brands'});
              }
            });
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });

        /*
        Swal.fire("Good job!", "Your industry is saved now!", "success")
        .then(() => {
          self.submitted = false;
          self.form.id_categories       = "";
          self.form.nm_brand = "";
        });
        */
      }
    },

    resetSite(){
      this.form.id_categories = "";
      this.form.id_brand  = "";
      this.form.nm_brand  = "";
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="saveBrand">
              <div class="row">
                <div class="col-lg-4" >
                  <h4 class="card-title">Brand</h4>
                  <p class="card-title-desc">Register a new brand into the system.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <!--<label for="id_categories">Category</label>-->
                        <vue-accessible-multiselect
                          v-model="form.id_categories"
                          :options="categories"
                          placeholder="SELECT YOUR CATEGORY"
                          label="Category"
                        ></vue-accessible-multiselect>
                        <!--
                        <b-form-select
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.id_categories.$error }"
                          name="id_categories"
                          id="id_categories"
                          v-model="form.id_categories"
                          size="sm"
                          multiple
                        >
                          <option value="">SELECT YOUR CATEGORY</option>
                          <option v-for="(category, index) in categories" :key="index" :value="category.id_categories">{{category.nm_category}}</option>
                        </b-form-select>
                        -->
                        <div v-if="submitted && $v.form.id_categories.$error" class="invalid-feedback">
                          <span v-if="!$v.form.id_categories.required">Category field is required.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <label for="nm_brand">Brand name</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_brand.$error }"
                          name="nm_brand"
                          id="nm_brand"
                          v-model="form.nm_brand"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_brand.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_brand.required">Brand name is required.</span>
                          <span v-if="!$v.form.nm_brand.minLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                          <span v-if="!$v.form.nm_brand.maxLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-4">
                </div>

                <div class="col-lg-4">
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">SAVE BRAND</button>
                    <router-link to="/equipment/brands" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>